import { defineComponent as _defineComponent } from 'vue'
import CaretRightIcon from '@/assets/images/svg/caret-right.svg?component';
import { TAppVersionReport, TSingleScanReport } from '@/_core/entities/report/models/types';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportBreadcrumbs',
  props: {
    reportData: null,
    integrationId: null,
    branchName: null
  },
  setup(__props: any) {

const props = __props as {
  reportData: TAppVersionReport | TSingleScanReport;
  integrationId?: string;
  branchName?: string;
};



const isIntegrationReport = computed(() => 'integrationName' in props.reportData);

const topLevelBreadcrumb = computed(() => {
  if (isIntegrationReport.value) {
    return (props.reportData as TAppVersionReport).integrationName || props.reportData.fileName;
  }

  return props.reportData.fileName;
});

const versionsLink = computed(() => {
  if (!props.integrationId || !props.branchName) return null;

  // should reflect the respective path in router.js
  return `/integration/${props.integrationId}/branch/${props.branchName}`;
});

return { __sfc: true,props, isIntegrationReport, topLevelBreadcrumb, versionsLink, CaretRightIcon }
}

})